<template>
  <div class="content">
    <div class="container doc-container">
      <h3>{{$t('docking.docSdkWord')}}</h3>
      <div class="doc-info">
        {{$t('docking.sdkTipOne')}}
      </div>
      <el-button type="primary" icon="el-icon-plus" class="handle-del mr10 fr" @click="handleAdd">{{$t("docking.addDevice")}}</el-button>
      <div class="table-container">
        <el-table :data="sdkTestingList" class="table">
          <el-table-column prop="device_id" :label="$t('docking.deviceID')" align="left"></el-table-column>
          <el-table-column prop="device_type" :label="$t('docking.deviceType')" align="left">
            <template slot-scope="scope">
              {{ scope.row.device_type | deviceTypeFliter($com.deviceList) }}
            </template>
          </el-table-column>
          <el-table-column prop="test_status" :label="$t('docking.testStatus')" align="left">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.test_status"
                :active-value="1"
                :inactive-value="0"
                active-color="#3361FF"
                inactive-color="#ff0000"
                @change="testStatusChange(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.operation')" align="left" width="190">
            <template slot-scope="scope">
              <el-button type="text" size="large" @click="handleDel(scope.row.id)">{{$t('operation.delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-size="listQuery.page_size"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="$t('docking.addDevice')"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="480px"
    >
    <el-form :model="formData" :rules="rules" ref="ruleForm" :label-width="labelWidth" label-position="left">
      <el-form-item :label="$t('table.area')" prop="area">
        <el-radio-group v-model="formData.area">
          <el-radio v-for="(item,index) in $com.areaList" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('common.APPplatform')" prop="os">
        <el-radio-group v-model="formData.os">
          <el-radio :label="1">Andriod</el-radio>
          <el-radio :label="2">iOS</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 设备id -->
      <el-form-item :label="$t('docking.deviceID')" prop="device_id">
        <el-input :placeholder="$t('common.enterContent')" v-model="formData.device_id" class="input-with-select" style="width: 300px">
          <el-select 
            v-model="formData.device_type" 
            filterable 
            slot="prepend" 
            :placeholder="$t('docking.deviceIDP')"
            style="width: 72px" 
          >
            <el-option
              v-for="(item,index) in deviceList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <p>{{ $t('docking.testSaveTip') }}</p>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :disabled="isDisabled">{{$t('save')}}</el-button>
      <el-button @click="handleClose">{{$t('cancel')}}</el-button>
    </span>
    </el-dialog>
  </div>
</template>


<script>
const formDataDefault = {
  area: 1,
  os: 1,
  device_id: "",
  device_type: 1,
}
export default {
  data() {
    return {
      isDisabled: false, // 防止重复点击
      timer: null,    
      visible: false,
      listQuery: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      formData:  Object.assign({}, formDataDefault),
      rules: {
        interactive_type: [
          { required: true, message: this.$t('sdk.interaction'), trigger: "change"},
        ],
        device_id: [
          { required: true, message: this.$t('sdk.deviceId'), trigger: "blur"},
        ],
        ad_zone_id: [
          { required: true, message: this.$t('sdk.adId'), trigger: "blur"},
        ],
      },
      sdkTestingList: [],
      adList: [],
      deviceList: [],
      labelWidth: '120px',
    }
  },
  watch: {
    '$i18n.locale'(newVal) {
      if(newVal == 'zh') {
        this.labelWidth = '80px'
      } else {
        this.labelWidth = '120px'
      }
    },
    'formData.area'(newVal) {
      this.updateDeviceList()
    },
    'formData.os'(newVal) {
      this.updateDeviceList()
    },
  },
  filters: {
    deviceTypeFliter(val, list) {
      let str = ""
      list.forEach(item => {
        if(item.id == val) {
          str = item.name
        }
      })
      return str
    }
  },
  created() {
    this.getSdkTestingList()
    this.getAdList()
    this.updateDeviceList()
  },
  beforeDestroy() {
    if(this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 分页导航
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getSdkTestingList()
    },
    handleSizeChange(val) {
      this.listQuery.page = 1
      this.listQuery.page_size = val
      this.getSdkTestingList()
    },
    // 获取广告位下拉列表
    getAdList() {
      let params = {
        os: 1,
        docking_type: 1,
      }
      this.__getData('getSdkZoneSelect', params , (res) => {
        this.adList = res.list
      })
    },
    updateDeviceList() {
      this.getDeviceListByType(this.formData.os, this.formData.area);
    },
    // 选了设备类型为安卓并且国家是国内，展示IMEI、OAID、IMEI-MD5、OAID-MD5；选了设备类型为安卓并且国家是国外，展示GAID、ANDROIDID；选了设备类型为ios并且国家是国内或者国外，展示IDFA、IDFA-MD5；
    getDeviceListByType(deviceType, area) {
      let filteredList = [];
      if (deviceType === 2) { // iOS
        filteredList = this.$com.deviceList.filter(device => device.os_type === 2);
      } else if (deviceType === 1) { // 安卓
        if (area === 1) { // 国内
          filteredList = this.$com.deviceList.filter(device => [1, 2, 4, 5].includes(device.id));
        } else if (area === 2) { // 海外
          filteredList = this.$com.deviceList.filter(device => [7, 8].includes(device.id));
        }
      }
      this.deviceList = filteredList;
      this.formData.device_type = this.deviceList.length > 0 ? this.deviceList[0].id : null;
    },
    // osChange(val) {
    //   if(val == 1) {
    //     this.formData.device_type = 1
    //   } else if(val == 2) {
    //     this.formData.device_type = 3
    //   }
    //   this.deviceList = this.$com.deviceList.filter(item => item.os_type == val)
    // },
    // areaChange(val) {
    //   if(val == 1) { //国内
    //     // 国内不展示GAID和ANDROIDID
    //     this.deviceList = this.deviceList.filter(item => item.id != 7 && item.id != 8)
    //   } 
    // },
    handleAdd() {
      this.visible =  true
      this.updateDeviceList()
    },
    handleDel(id) {
      this.__postData('delSdkTesting', {id: id} , (res) => {
        this.$message.success(this.$t('message.delete'));
        this.getSdkTestingList()
      })
    },
    getSdkTestingList() {
      this.__getData('getSdkTestingList', this.listQuery, (res) => {
        if(res.code == 1) {
          this.$message.error(res.msg)
        } else {
          this.sdkTestingList = res.list
          this.total = res.total
        }
      })
    },
    submitForm() {
      this.isDisabled = true  
      this.timer = setTimeout(() => { 
        this.isDisabled = false
        clearTimeout(this.timer)
      }, 1500);
      this.$refs.ruleForm.validate((valid) => {
        if(valid) {
          this.__postData('addSdkTesting', this.formData, (res) => {
            clearTimeout(this.timer)
            this.timer = null
            this.$message.success(this.$t('message.successSava'));
            this.handleClose()
            this.getSdkTestingList()
            this.isDisabled = false
          })
        } else {
          this.isDisabled = false;
          clearTimeout(this.timer); 
          this.timer = null;
          this.$message.error(this.$t('message.errorComplete'));
        }
      })
    },
    // 切换状态
    testStatusChange(row) {
      let params = {
        id: row.id,
        test_status: row.test_status,
      }
      this.__postData('updateTestStatus', params, (res) => {
        this.$message.success(row.test_status == 1? this.$t('status.open'): this.$t('status.closed'));
        this.getSdkTestingList()
      })
    },
    handleClose() {
      this.visible =  false
      this.formData = Object.assign({}, formDataDefault)
      this.$refs.ruleForm.clearValidate()
    }
  }
}
</script>

<style>
.doc-info {
  margin-bottom: 34px;
  margin-top: 14px;
  font-size: 14px;
}
</style>